export default __webpack_public_path__ + "d96d2ffd04646a475b2dc2950df4e75f.png";